<div class="tabs">
  @for (tab of tabs; track trackByTab($index, tab)) {
    <div
      class="tab"
      [class.attention-flash]="isFlashing(tab.key)"
      [class.active]="tab.key === selectedTab"
      [hidden]="!tab.enabled"
      (click)="select(tab.key)">
      <span class="tab-label">{{ tab.label }}</span>

    </div>

    @if (hasAnySelectedForTab(tab.key)) {
      <span class="tab-indicator material-icons" aria-hidden="true">check_circle</span>
    }
  }
</div>
